// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__VazWc","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__827aG"};